import { render } from "./twoindex.vue?vue&type=template&id=78c69536&scoped=true"
import script from "./twoindex.vue?vue&type=script&lang=js"
export * from "./twoindex.vue?vue&type=script&lang=js"

import "./twoindex.vue?vue&type=style&index=0&id=78c69536&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zxr_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c69536"]])

export default __exports__